
export const SERVER_API_URL = 'https://apipad.eucleia.net/';
// export const SERVER_API_URL = 'http://localhost:9000/';